import jsPDF from 'jspdf'
import Moment from 'moment';
import {client} from '../Client';

require('jspdf-autotable');
require('../jsPdfTextEx.js');


class PdfGenerator {

    constructor(){
        this.title = '';
        this.filterDescription = '';
        this.items = [];
        this.pdf = null;
        this.fileName = 'output.pdf';
        this.totalPagesExp = "{total_pages_count_string}";
        this.orientation = 'l';
        this.ultimaModificaText = '';

        this.setTitle = this.setTitle.bind(this);
        this.setFileName = this.setFileName.bind(this);
        this.getCreatorMessage = this.getCreatorMessage.bind(this);
        this.doPageContent = this.doPageContent.bind(this);
        this.createPdf = this.createPdf.bind(this);
        this.doDrawHeaderRow = this.doDrawHeaderRow.bind(this);
        this.doDrawRow = this.doDrawRow.bind(this);
    }

    setTitle(value){
        this.title = value;
    }

    getTitle() {
        return this.title ? this.title : '';
    }

    setOrientationPortrait(){
        this.orientation = 'p';
    }
    setOrientationLandscape(){
        this.orientation = 'l';
    }

    setFileName(value){
        this.fileName = value;
    }

    getFooterExtraMessage(){
        return this.ultimaModificaText;
    }
    getCreatorMessage(){
        return client.getNomeApp() + " " + client.getVersione() + " - Stampa eseguita il " + Moment().format("DD-MM-YYYY") + " " +
            Moment().format("HH:mm:ss") + " da " + client.getCurrentUser().username +
            " " + this.getFooterExtraMessage();
    }

    setFilterDescription(value){
        this.filterDescription = value;
    }

    getFilterDescription() {
        return this.filterDescription ? this.filterDescription : '';
    }

    setItems(items){
        this.items = items;
    }

    doPageContent(data) {
        // HEADER
        if (data.pageCount === 1) {
            this.doDrawHeader(data);
        }

        // FOOTER
        // let strPage = "Pagina " + data.pageCount;
        let strPage = "" + data.pageCount;
        // Total page number plugin only available in jspdf v1.0+
        if (typeof this.pdf.putTotalPages === 'function') {
            strPage = strPage + " di " + this.totalPagesExp;
        }
        let filterDesc =  this.getFilterDescription();

        if (filterDesc) {
            filterDesc = filterDesc.replace(/(?:\r\n|\r|\n)/g, ' ');
            // filterDesc = ' - ' + filterDesc;
            // let textLen = this.orientation === 'l' ? 100: 100;
            // if (filterDesc.length > textLen){
            //     filterDesc = filterDesc.substr(0, textLen) + '...';
            // }
        }
        this.pdf.setFontSize(9);
        this.pdf.text(filterDesc, data.settings.margin.left, this.pdf.internal.pageSize.height - 27);
        this.pdf.text(this.getCreatorMessage(), data.settings.margin.left, this.pdf.internal.pageSize.height - 15);
        this.pdf.textEx(strPage,  this.pdf.internal.pageSize.width + 76, this.pdf.internal.pageSize.height - 15, "right", "bottom");
        this.pdf.setLineWidth(1);
        //this.pdf.setDrawColor(0x56, 0x9e, 0xdd);
        this.pdf.setDrawColor(0);
        this.pdf.line(data.settings.margin.left, this.pdf.internal.pageSize.height - 37,  this.pdf.internal.pageSize.width -  data.settings.margin.right, this.pdf.internal.pageSize.height - 37);
    };

    doDrawHeader(data){
        this.pdf.setFontSize(20);
        this.pdf.setTextColor(40);
        this.pdf.setFontStyle('normal');
        this.pdf.text(this.getTitle(), data.settings.margin.left, data.settings.margin.top+10);
        this.pdf.setFontSize(9);
        this.pdf.setTextColor(100,100,100);
        this.pdf.setFontStyle('normal');
        //this.pdf.text(this.getFilterDescription(), data.settings.margin.left, data.settings.margin.top - 8);
        this.pdf.autoTableText(this.getFilterDescription(), data.settings.margin.left , data.settings.margin.top+22, {
            halign: 'left',
            valign: 'middle'
        });
    }

    doDrawHeaderRow(row, data){
        this.pdf.setLineWidth(1.5);
        this.pdf.setDrawColor(0);
        this.pdf.line(data.settings.margin.left, row.y +row.height-2,  this.pdf.internal.pageSize.width -  data.settings.margin.right, row.y+row.height-2);
    }

    doDrawRow(row, data){
        this.pdf.setLineWidth(0.5);
        this.pdf.setDrawColor(100);
        this.pdf.line(data.settings.margin.left, row.y-1 ,  this.pdf.internal.pageSize.width -  data.settings.margin.right, row.y-1);
    }

    createPdfFromHtmlTable(htmlElement, options){
        this.pdf = new jsPDF(this.orientation, 'pt', 'a4');
        let res = this.pdf.autoTableHtmlToJson(htmlElement);
        this.createPdfInternal(res.columns, res.rows, options);
    }

    createPdf(columns, rows, options){
        this.pdf = new jsPDF(this.orientation, 'pt', 'a4');
        this.createPdfInternal(columns, rows, options);
    }

    createPdfInternal(columns, rows, options){

        this.pdf.autoTable(columns, rows,
            Object.assign({
            addPageContent: this.doPageContent,
            drawHeaderRow: this.doDrawHeaderRow,
            drawRow: this.doDrawRow,
            startY: 50,
            margin: [20, 20, 50, 30],
            styles: {fontSize: 9, overflow: 'linebreak', columnWidth: 'wrap'},
            bodyStyles: {valign: 'top'},
            headerStyles: {
                valign: 'middle',
                //fillColor: [0x56, 0x9e, 0xdd],
                //fillColor: [0xFF, 0xFF, 0xFF],
                fillColor: false,
                textColor: [0,0,0],
            },
        }, options));
        if (typeof this.pdf.putTotalPages === 'function') {
            this.pdf.putTotalPages(this.totalPagesExp);
        }
        //this.pdf.save(this.fileName);

        let blob = this.pdf.output("blob");
        window.open(URL.createObjectURL(blob));
        // let pdfout = this.pdf.output('datauristring');
        // let iframe = "<html><head><title>" + this.getTitle() + "</title></head><body style='margin:0px'><iframe frameBorder='0' width='100%' height='100%' src='" + pdfout + "'></iframe></body></html>"
        //
        // let x = window.open();
        // x.document.open();
        // x.document.write(iframe);
        // x.document.close();
    }

    formatCurrency(value, numdecimals = 2){
        return this.formatDecimal(value, numdecimals);
    }
    formatDecimal(value, numdecimals = 2){
        return Number.parseFloat(value).toLocaleString('it-IT', {minimumFractionDigits: numdecimals, maximumFractionDigits: numdecimals})
    }
}

export default PdfGenerator;


/** WEBPACK FOOTER **
 ** ./src/pdf/PdfGenerator.js
 **/